"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var extractCustomerInfo = function extractCustomerInfo(customerInfo) {
  var customer = {
    uuId: 'no_user.uuid',
    banType: 'no_user.bantype',
    subscriptionId: 'no_user.subscriptionid'
  };
  customer.uuId = customerInfo.profile.profileUUID;
  var bansList = customerInfo.bans;
  var typeCdList = [];
  var subTypeCdList = [];
  var productIdList = [];
  var banTypelist = [];
  bansList.forEach(function (ban) {
    Object.entries(ban).forEach(function (_ref) {
      var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      if (key === 'typeCd') {
        typeCdList.push(value);
      }
      if (key === 'subTypeCd') {
        subTypeCdList.push(value);
      }
      if (key === 'products') {
        value.forEach(function (product) {
          Object.entries(product).forEach(function (_ref3) {
            var _ref4 = (0, _slicedToArray2["default"])(_ref3, 2),
              productKey = _ref4[0],
              productValue = _ref4[1];
            if (productKey === 'productId') {
              productIdList.push(productValue);
            }
          });
        });
      }
    });
  });
  typeCdList.forEach(function (cd, i) {
    return banTypelist.push("".concat(cd, "|").concat(subTypeCdList[i]));
  });
  customer.banType = banTypelist.join(',');
  customer.subscriptionId = productIdList.join(',');
  return customer;
};
var customerApi = /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(apiBaseUrl) {
    var additionalHeader, requestHeader, response, status;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            additionalHeader = {
              't-target': 'customer',
              't-credentials': 1
            };
            requestHeader = {
              method: 'GET',
              headers: additionalHeader,
              credentials: 'include'
            };
            _context.prev = 2;
            _context.next = 5;
            return fetch("".concat(apiBaseUrl, "/api/v2/customer"), requestHeader);
          case 5:
            response = _context.sent;
            status = response.status;
            if (!(status >= 400)) {
              _context.next = 9;
              break;
            }
            throw new Error('Bad response from server');
          case 9:
            _context.next = 11;
            return response.json();
          case 11:
            return _context.abrupt("return", _context.sent);
          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](2);
            return _context.abrupt("return", _context.t0);
          case 17:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 14]]);
  }));
  return function customerApi(_x) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Check if user is authenticated
 *
 * @param {string} apiBaseUrl
 * @returns {object} - response
 */
var authStatus = /*#__PURE__*/function () {
  var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(apiBaseUrl) {
    var additionalHeader, requestHeader, response, status;
    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            additionalHeader = {
              pragma: 'no-cache',
              'cache-control': 'no-cache',
              't-credentials': 1
            };
            requestHeader = {
              method: 'GET',
              headers: additionalHeader,
              credentials: 'include'
            };
            _context2.prev = 2;
            _context2.next = 5;
            return fetch("".concat(apiBaseUrl, "/authentication/status"), requestHeader);
          case 5:
            response = _context2.sent;
            status = response.status;
            if (!(status >= 400)) {
              _context2.next = 9;
              break;
            }
            throw new Error('Bad response from server');
          case 9:
            _context2.next = 11;
            return response.json();
          case 11:
            return _context2.abrupt("return", _context2.sent);
          case 14:
            _context2.prev = 14;
            _context2.t0 = _context2["catch"](2);
            return _context2.abrupt("return", _context2.t0);
          case 17:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[2, 14]]);
  }));
  return function authStatus(_x2) {
    return _ref6.apply(this, arguments);
  };
}();
var fetchUserPersona = /*#__PURE__*/function () {
  var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3() {
    var additionalHeader, requestHeader, _json$data, response, json;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            additionalHeader = {
              't-credentials': 1,
              'Content-Type': 'application/json',
              't-oauth2-token': '1',
              't-session-token': '1'
            };
            requestHeader = {
              method: 'GET',
              headers: additionalHeader,
              credentials: 'include'
            };
            _context3.prev = 2;
            _context3.next = 5;
            return fetch('/selfserve/api/v2/customer/user-persona-details', requestHeader);
          case 5:
            response = _context3.sent;
            if (response.ok) {
              _context3.next = 8;
              break;
            }
            return _context3.abrupt("return", {});
          case 8:
            _context3.next = 10;
            return response.json();
          case 10:
            json = _context3.sent;
            return _context3.abrupt("return", (_json$data = json === null || json === void 0 ? void 0 : json.data) !== null && _json$data !== void 0 ? _json$data : {});
          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](2);
            return _context3.abrupt("return", {});
          case 17:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[2, 14]]);
  }));
  return function fetchUserPersona() {
    return _ref7.apply(this, arguments);
  };
}();
var determineIfCustomerHasRegisteredForSubscriptionOnDemand = function determineIfCustomerHasRegisteredForSubscriptionOnDemand(userPersona) {
  var _userPersona$status;
  var status = (_userPersona$status = userPersona === null || userPersona === void 0 ? void 0 : userPersona.status) !== null && _userPersona$status !== void 0 ? _userPersona$status : {};
  if (status.statusSubsCd === 'OK' && userPersona.getPersonaList) {
    return userPersona.getPersonaList.some(function (persona) {
      var _persona$LinkageList;
      return (_persona$LinkageList = persona.LinkageList) === null || _persona$LinkageList === void 0 ? void 0 : _persona$LinkageList.some(function (linkage) {
        return linkage.customerId && linkage.linkageStatus === 'ACTIVE';
      });
    });
  }
  return false;
};
var determineMobilityorSodcustomer = function determineMobilityorSodcustomer(bansList, userPersona) {
  var isSod = _get__("determineIfCustomerHasRegisteredForSubscriptionOnDemand")(userPersona);
  var isMobility = (bansList === null || bansList === void 0 ? void 0 : bansList.length) > 0;
  if (isMobility && isSod) {
    return 'MOBILITY_SUBSCRIPTION';
  }
  if (isMobility) {
    return 'MOBILITY_ONLY';
  }
  return 'SUBSCRIPTION_ONLY';
};
var USER_OPTIONS = {
  AUTH: {
    AUTHED: 'logged in',
    NOT_AUTHED: 'not logged in'
  }
};

/**
 * Set dataLayer with user profile and auth details if logged in
 *
 * @param {string} apiBaseUrl
 * @param {object} page - page data
 * @param {object} user - explicitly set user data
 * @return {void}
 */
var setDataLayer = /*#__PURE__*/function () {
  var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(apiBaseUrl, page) {
    var user,
      event,
      _user,
      _event,
      hasfetchedUserPersona,
      authResponse,
      profileResponse,
      customerInfo,
      userPersona,
      dataLayerPopulatedEvent,
      _args4 = arguments;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            user = _args4.length > 2 && _args4[2] !== undefined ? _args4[2] : {};
            event = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : {};
            window.dataLayer = window.dataLayer || {};
            _user = window.dataLayer.user || {};
            _user = _objectSpread(_objectSpread({}, _user), user);
            _event = window.dataLayer.event || {};
            _event = _objectSpread(_objectSpread({}, _event), event);
            hasfetchedUserPersona = false;
            _context4.prev = 8;
            _context4.next = 11;
            return _get__("authStatus")(apiBaseUrl);
          case 11:
            authResponse = _context4.sent;
            if (!authResponse.isValid) {
              _context4.next = 53;
              break;
            }
            _context4.next = 15;
            return _get__("customerApi")(apiBaseUrl);
          case 15:
            profileResponse = _context4.sent;
            if (!('profile' in profileResponse)) {
              _context4.next = 28;
              break;
            }
            customerInfo = _get__("extractCustomerInfo")(profileResponse);
            _user.uuid = customerInfo.uuId;
            _user.bantype = customerInfo.banType;
            if (!_user.subscriptionid) {
              if (page.subscriberId && customerInfo.subscriptionId.includes(page.subscriberId)) {
                _user.subscriptionid = page.subscriberId;
              } else if (page.subscriberId === null) {
                _user.subscriptionid = '';
              } else {
                _user.subscriptionid = customerInfo.subscriptionId;
              }
            }
            if (window.dataLayer.__fetchedUserPersona) {
              _context4.next = 28;
              break;
            }
            window.dataLayer.__fetchedUserPersona = true;
            hasfetchedUserPersona = true;
            _context4.next = 26;
            return _get__("fetchUserPersona")();
          case 26:
            userPersona = _context4.sent;
            _user.mobilityorsodcustomer = _get__("determineMobilityorSodcustomer")(profileResponse.bans, userPersona);
          case 28:
            _context4.t0 = _user.mobilityorsodcustomer;
            _context4.next = _context4.t0 === 'MOBILITY_ONLY' ? 31 : _context4.t0 === 'MOBILITY_SUBSCRIPTION' ? 36 : _context4.t0 === 'SUBSCRIPTION_ONLY' ? 41 : 46;
            break;
          case 31:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.AUTHED;
            _user.customertype = 'existing';
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 51);
          case 36:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.AUTHED;
            _user.customertype = 'existing';
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.AUTHED;
            _user.sodcustomertype = 'existing';
            return _context4.abrupt("break", 51);
          case 41:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.customertype = 'prospect';
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.AUTHED;
            _user.sodcustomertype = 'existing';
            return _context4.abrupt("break", 51);
          case 46:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.AUTHED;
            _user.customertype = 'existing';
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 51);
          case 51:
            _context4.next = 72;
            break;
          case 53:
            hasfetchedUserPersona = true;
            // check what type of customer is logged in
            // 'MOBILITY_ONLY' | 'MOBILITY_SUBSCRIPTION' | 'SUBSCRIPTION_ONLY'
            _context4.t1 = _user.mobilityorsodcustomer;
            _context4.next = _context4.t1 === 'MOBILITY_ONLY' ? 57 : _context4.t1 === 'MOBILITY_SUBSCRIPTION' ? 61 : _context4.t1 === 'SUBSCRIPTION_ONLY' ? 65 : 68;
            break;
          case 57:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 72);
          case 61:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 72);
          case 65:
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 72);
          case 68:
            _user.loginstate = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodloginstatus = _get__("USER_OPTIONS").AUTH.NOT_AUTHED;
            _user.sodcustomertype = 'prospect';
            return _context4.abrupt("break", 72);
          case 72:
            _context4.next = 76;
            break;
          case 74:
            _context4.prev = 74;
            _context4.t2 = _context4["catch"](8);
          case 76:
            _context4.prev = 76;
            window.dataLayer.page = page;
            window.dataLayer.user = _user;
            window.dataLayer.event = _event;
            if (!window.dataLayer.__dataLayerPopulatedFired && hasfetchedUserPersona) {
              window.dataLayer.__dataLayerPopulatedFired = true;
              dataLayerPopulatedEvent = new CustomEvent('dataLayerPopulated', {
                detail: {
                  page: page,
                  user: _user
                }
              });
              window.dispatchEvent(dataLayerPopulatedEvent);
            }
            return _context4.finish(76);
          case 82:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[8, 74, 76, 82]]);
  }));
  return function setDataLayer(_x3, _x4) {
    return _ref8.apply(this, arguments);
  };
}();
module.exports = {
  setDataLayer: _get__("setDataLayer")
};
function _getGlobalObject() {
  try {
    if (!!global) {
      return global;
    }
  } catch (e) {
    try {
      if (!!window) {
        return window;
      }
    } catch (e) {
      return this;
    }
  }
}
;
var _RewireModuleId__ = null;
function _getRewireModuleId__() {
  if (_RewireModuleId__ === null) {
    var globalVariable = _getGlobalObject();
    if (!globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__) {
      globalVariable.__$$GLOBAL_REWIRE_NEXT_MODULE_ID__ = 0;
    }
    _RewireModuleId__ = __$$GLOBAL_REWIRE_NEXT_MODULE_ID__++;
  }
  return _RewireModuleId__;
}
function _getRewireRegistry__() {
  var theGlobalVariable = _getGlobalObject();
  if (!theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__) {
    theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
  }
  return theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__;
}
function _getRewiredData__() {
  var moduleId = _getRewireModuleId__();
  var registry = _getRewireRegistry__();
  var rewireData = registry[moduleId];
  if (!rewireData) {
    registry[moduleId] = Object.create(null);
    rewireData = registry[moduleId];
  }
  return rewireData;
}
(function registerResetAll() {
  var theGlobalVariable = _getGlobalObject();
  if (!theGlobalVariable['__rewire_reset_all__']) {
    theGlobalVariable['__rewire_reset_all__'] = function () {
      theGlobalVariable.__$$GLOBAL_REWIRE_REGISTRY__ = Object.create(null);
    };
  }
})();
var INTENTIONAL_UNDEFINED = '__INTENTIONAL_UNDEFINED__';
var _RewireAPI__ = {};
(function () {
  function addPropertyToAPIObject(name, value) {
    Object.defineProperty(_RewireAPI__, name, {
      value: value,
      enumerable: false,
      configurable: true
    });
  }
  addPropertyToAPIObject('__get__', _get__);
  addPropertyToAPIObject('__GetDependency__', _get__);
  addPropertyToAPIObject('__Rewire__', _set__);
  addPropertyToAPIObject('__set__', _set__);
  addPropertyToAPIObject('__reset__', _reset__);
  addPropertyToAPIObject('__ResetDependency__', _reset__);
  addPropertyToAPIObject('__with__', _with__);
})();
function _get__(variableName) {
  var rewireData = _getRewiredData__();
  if (rewireData[variableName] === undefined) {
    return _get_original__(variableName);
  } else {
    var value = rewireData[variableName];
    if (value === INTENTIONAL_UNDEFINED) {
      return undefined;
    } else {
      return value;
    }
  }
}
function _get_original__(variableName) {
  switch (variableName) {
    case "determineIfCustomerHasRegisteredForSubscriptionOnDemand":
      return determineIfCustomerHasRegisteredForSubscriptionOnDemand;
    case "authStatus":
      return authStatus;
    case "customerApi":
      return customerApi;
    case "extractCustomerInfo":
      return extractCustomerInfo;
    case "fetchUserPersona":
      return fetchUserPersona;
    case "determineMobilityorSodcustomer":
      return determineMobilityorSodcustomer;
    case "USER_OPTIONS":
      return USER_OPTIONS;
    case "setDataLayer":
      return setDataLayer;
  }
  return undefined;
}
function _assign__(variableName, value) {
  var rewireData = _getRewiredData__();
  if (rewireData[variableName] === undefined) {
    return _set_original__(variableName, value);
  } else {
    return rewireData[variableName] = value;
  }
}
function _set_original__(variableName, _value) {
  switch (variableName) {}
  return undefined;
}
function _update_operation__(operation, variableName, prefix) {
  var oldValue = _get__(variableName);
  var newValue = operation === '++' ? oldValue + 1 : oldValue - 1;
  _assign__(variableName, newValue);
  return prefix ? newValue : oldValue;
}
function _set__(variableName, value) {
  var rewireData = _getRewiredData__();
  if (_typeof(variableName) === 'object') {
    Object.keys(variableName).forEach(function (name) {
      rewireData[name] = variableName[name];
    });
    return function () {
      Object.keys(variableName).forEach(function (name) {
        _reset__(variableName);
      });
    };
  } else {
    if (value === undefined) {
      rewireData[variableName] = INTENTIONAL_UNDEFINED;
    } else {
      rewireData[variableName] = value;
    }
    return function () {
      _reset__(variableName);
    };
  }
}
function _reset__(variableName) {
  var rewireData = _getRewiredData__();
  delete rewireData[variableName];
  if (Object.keys(rewireData).length == 0) {
    delete _getRewireRegistry__()[_getRewireModuleId__];
  }
  ;
}
function _with__(object) {
  var rewireData = _getRewiredData__();
  var rewiredVariableNames = Object.keys(object);
  var previousValues = {};
  function reset() {
    rewiredVariableNames.forEach(function (variableName) {
      rewireData[variableName] = previousValues[variableName];
    });
  }
  return function (callback) {
    rewiredVariableNames.forEach(function (variableName) {
      previousValues[variableName] = rewireData[variableName];
      rewireData[variableName] = object[variableName];
    });
    var result = callback();
    if (!!result && typeof result.then == 'function') {
      result.then(reset)["catch"](reset);
    } else {
      reset();
    }
    return result;
  };
}
var _typeOfOriginalExport = _typeof(module.exports);
function addNonEnumerableProperty(name, value) {
  Object.defineProperty(module.exports, name, {
    value: value,
    enumerable: false,
    configurable: true
  });
}
if ((_typeOfOriginalExport === 'object' || _typeOfOriginalExport === 'function') && Object.isExtensible(module.exports)) {
  addNonEnumerableProperty('__get__', _get__);
  addNonEnumerableProperty('__GetDependency__', _get__);
  addNonEnumerableProperty('__Rewire__', _set__);
  addNonEnumerableProperty('__set__', _set__);
  addNonEnumerableProperty('__reset__', _reset__);
  addNonEnumerableProperty('__ResetDependency__', _reset__);
  addNonEnumerableProperty('__with__', _with__);
  addNonEnumerableProperty('__RewireAPI__', _RewireAPI__);
}